import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full bg-background-50 min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16 flex flex-col items-center justify-center text-center px-6 py-20">
        <span className="w-16 h-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
          <i className="ri-emotion-unhappy-line text-3xl" />
        </span>
        <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mt-5">
          404 · 这个页面不见了
        </h1>
        <p className="text-sm text-foreground-500 mt-2 font-mono break-all">{location.pathname}</p>
        <p className="text-sm text-foreground-600 mt-4 max-w-md">
          你访问的页面可能已经被移走，或者链接不太对。不如回首页找个乐子？
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-search-line" />
            去搜索内容
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}